import { FormCheck } from 'react-bootstrap';
import { FloatingLabel } from './FloatingLabel';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { withComponentCapabilities } from './capabilities/componentCapabilities';
import { materializeValue } from '../utils/lazyValue';

export const toString = async ({ value, defaultValue, t }) => (await materializeValue(value)) ? t('yes') : t('no');

/**
 * General purpose Bootstrap Checkbox component
 * @component
 */
const Checkbox = withComponentCapabilities(({ onChange, placeholder, checked, hideLabel = false, disabled = false, id: idInput, ...props }) => {
  const [id] = useState(idInput ?? crypto.randomUUID().replaceAll('-',''));
  const [innerChecked, setInnerChecked] = useState(checked);

  useEffect(() => setInnerChecked(checked), [checked]);

  return <FloatingLabel hideLabel={hideLabel}><FormCheck id={id} checked={innerChecked} disabled={disabled} {...props} onChange={e => { setInnerChecked(e.target.checked); onChange(e.target.checked) }} label={placeholder}></FormCheck></FloatingLabel>
}, {
  lazyProps: ['checked']
});

Checkbox.propTypes = {
    /**
     * Unique reference for the Checkbox
     */
    id: PropTypes.string,
    /**
     * The current checked state of the control
     */
    checked: PropTypes.bool,
    /**
     * Function called whenever the checkbox is toggled
     */
    onChange: PropTypes.func.isRequired,
    /**
     * The label for the checkbox
     */
    placeholder: PropTypes.string,
    /**
     * Force the checkbox to be read-only
     */
    disabled: PropTypes.bool,
    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool
}

export default Checkbox;